import { useQuery } from "@tanstack/react-query";

import { useGroupReferences } from "@contexts/GroupReferences/GroupReferences.context";

import { apiEcmsHttp } from "../http";
import { QUERY_KEYS } from "../keys";
import type { UserWithAuthorizations } from "./apiEcms.types";

const getUser = (id: string, signal: AbortSignal) =>
  apiEcmsHttp.get<UserWithAuthorizations>(`/users/${id}`, { signal });

export const useGetUser = (id: string, enabled?: boolean) => {
  const { currentGroup } = useGroupReferences();

  return useQuery({
    queryKey: [QUERY_KEYS.USER, id, currentGroup],
    queryFn: ({ signal }) => getUser(id, signal),
    select: ({ data }) => data,
    enabled,
  });
};
